export default __webpack_public_path__ + "static/black-logo-c32b5ed1c5504ea2e21d4d8ea31f21e6.svg";